const Appsignal = require("@appsignal/javascript").default
const appsignal = new Appsignal({ key: "6d9ba55a-e86c-4614-af14-e95aba0f38b5" })
export default appsignal
